module.exports = __webpack_public_path__ + "686905825cfbf1d53139042de19e6001.mp3";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/goed_gedaan.mp3
// module id = 101
// module chunks = 0